import type { IMosaicTocExpanded } from "./interface";

/**
 * Hides the refresh-required alert.
 *
 * @param state - The current expanded ToC state.
 * @returns The updated ToC state with the refresh alert hidden.
 */
export const toc_closeTocNeedRefresh = (state: IMosaicTocExpanded): IMosaicTocExpanded => ({
  ...state,
  showNeedRefresh: false,
});
